import { motion } from 'framer-motion'

import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const StyledDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;

  ${mq.medium} {
    margin-bottom: 7rem;
  }

  ${mq.large} {
    margin-bottom: 10rem;
  }
`

export const Toggle = styled.div`
  width: 100%;
  cursor: pointer;
  order: 1;
  font-size: 1.2rem;
  ${mq.smallOnly} {
    * {
      line-height: 1.5;
    }
  }
  ${mq.medium} {
    font-size: inherit;
  }

  & + *,
  & + * > *:first-child,
  & + * > *:first-child > *:first-child {
    margin-top: 0;
  }
`

export const Cover = styled(motion.div)`
  display: flex;
  overflow: hidden;
`

export const CoverImage = styled(motion.img)`
  display: block;
  object-fit: cover;
  object-position: 0 0;
  width: 100%;
`
